module.exports = "https://cdn2-fs.clearscore.com/flux/images/b533bd6d7af2d430904d10ef28d35ccd.jpg";